import { render, staticRenderFns } from "./UserFormSubmitted.vue?vue&type=template&id=0d41a5de&scoped=true&"
import script from "./UserFormSubmitted.vue?vue&type=script&lang=js&"
export * from "./UserFormSubmitted.vue?vue&type=script&lang=js&"
import style0 from "./UserFormSubmitted.vue?vue&type=style&index=0&id=0d41a5de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d41a5de",
  null
  
)

export default component.exports